import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { BaseEndpoint } from '../app.constants';
import { Headers, Http } from '@angular/http';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { PropertyType, AddPropertyType } from './property-type.model';
@Injectable()
export class PropertyTypeService {

    @Output() requestAdded = new EventEmitter<any[]>();
    @Output() propertyTypeAdded = new EventEmitter<any>();
    @Output() propertyTypeUpdated = new EventEmitter<any>();
    @Output() propertyTypeDeleted = new EventEmitter<any>();
    private propertyType: PropertyType[] = [];

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService) { }

    async getPropertyTypes() {
        const url = this.baseApiUrl + 'v1/propertytypes';
        let header = await this.adalService.createServiceHeader();
        return this.http.get(url, { headers: header }).toPromise().then(resp => {
            return resp.json().body;
        }).catch(this.handleError);
    }


    async addPropertyTypes(propertyType) {
        const url = this.baseApiUrl + 'v1/propertytype';
        let header = await this.adalService.createServiceHeader();
        return this.http.post(url, JSON.stringify(propertyType), { headers: header }).toPromise().then(resp => {
            const newSkillset = resp.json().body as PropertyType;
            this.propertyTypeAdded.emit(newSkillset);
            return newSkillset;
        }).catch(this.handleError);
    }

    updatePropertyTypes(propertyType: PropertyType): Promise<PropertyType> {
        const url = this.baseApiUrl + 'v1/propertytype/update/' + propertyType.id;
        return this.http
            .put(url, JSON.stringify(propertyType), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;
                if (success) {
                    this.propertyTypeUpdated.emit(propertyType);
                }
                return success;
            })
            .catch(resp => {
                var errors = resp.json().messages;
                if (errors)
                    return this.handleError(errors.map(({ description }) => description));
                else
                    return this.handleError(null);
            });
    }

    deletePropertyTypes(propertyTypeId: string): Promise<boolean> {
        var url = this.baseApiUrl + 'v1/propertytype/delete/' + propertyTypeId;
        return this.http
            .delete(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;
                if (success) {
                    this.propertyTypeDeleted.emit(propertyTypeId);
                }
                return success;
            })
            .catch(this.handleError);
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-type.service.ts